
<div class="ibox-content">
    <div class="table-responsive">
        <table class="table table-bordered table-striped cctv_datatable" id="studenttables">
            <thead>
                <tr *ngFor="let item of headdata">
                    <th>
                        <input type="checkbox" id="selectAll" class="main"
                            >
                    </th>
                    <th>{{item.admNo}}</th>
                    <th>{{item.studentName}}</th>
                    <th>{{item.dob}}</th>
                    <th>{{item.className}}</th>
                    <th>{{item.section}}</th>
                    <th>{{item.programName}}</th>
                    <th>{{item.examProgram}}</th>

                </tr>
            </thead>
            <tbody>
                <ng-container>
                    <tr *ngFor="let data of table">
                        <td>
                            <input type="checkbox" 
                                >
                        </td>
                        <td style="font-family: montserrat,sans-serif;">{{data.admNo}}</td>
                        <td style="font-family: montserrat,sans-serif;">{{data.studentName}}
                        </td>
                        <td style="font-family: montserrat,sans-serif;">{{data.dob}}</td>
                        <td style="font-family: montserrat,sans-serif;">{{data.className}}</td>
                        <td style="font-family: montserrat,sans-serif;">{{data.section}} </td>
                      
                        

                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
<div class="col-lg-12 text-center">
    <button type="button" class="cctv_notebtn" (click)="onSubmit()">Submit</button>
</div>